import React from 'react';
import './style.css';

type ContainerProps = {
	children?: React.ReactNode;
	style?: React.CSSProperties;
	className?: string;
};

export default function Container({
	children,
	className = '',
	...rest
}: ContainerProps) {
	return (
		<div className={`custom-container ${className}`} {...rest}>
			{children}
		</div>
	);
}
